import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@umss/shared/data-access';

export const emailVerifiedGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const user = auth.authState().user;

  if (user?.emailVerified) return true;

  router.navigateByUrl('/verify-email');

  return false;
};
